import {
  MergeTagsPlugin,
  mergeTagsContentStyle,
} from '../../tinymce/plugins';
import {CodePlugin} from './codePlugin';
import {DEFAULT_MERGE_TAGS} from './constants';

export const createDefaultContent = (email?: string) => {
  return {
    subject: '',
    value: '', // actual message
    recipients: email || '',
    cc: '',
    bcc: '',
    // attachments: '', // handled on the BE
    merge_pdf_config: {},
    merge_csv_config: {},
    smtp_from: '',
    smtp_from_fullname: '',
    integration_id: '',
    /*
     * Only send email if all attachments are available
     */
    send_with_all_attachments: true,
  }
};

export function parseHTML(content: string): string {
  // remove new lines
  content = content.replace(/\n/g, '');
  // format "<" and ">" in case they're used for comparison inside JINJA statements
  content = content.replace(/&lt;/g, '<');
  content = content.replace(/&gt;/g, '>');

  return content;
}

const no_image_style = (
  ""
  /*"img.content-image { width: 1px; height: 1px; } " +
  "img.content-image:before {" +
  " content: 'Image preview not available'; position: absolute; display: block; text-align: center; " +
  " width: 190px; height: 18px; line-height: 18px; background-color: #eee; } "*/
);

// define tinymce body content style as inline style
const content_style = (
  "body { font-family: Arial; font-size: 14px; } " +
  "body > p, body > pre { margin: 5px 0 6px 0; } " +
  no_image_style +
  mergeTagsContentStyle
);

export const initialProps = () => {
  return {
    skin: false,
    content_css: false,
    content_style,
    height: 300,
    min_height: 250,
    max_height: 550,
    menubar: 'edit format insert',
    menu: {
      /* override default menu `edit` from tinymce in order to add `code` menu item */
      edit: {
        title: 'Edit',
        items: 'undo redo | cut copy paste pastetext | selectall | code'
      },
    },
    default_link_target: '_blank',
    link_title: false,
    target_list: false,
    custom_colors: false,
    // relative_urls: false, // show whole URL, do not remove host
    // remove_script_host: false,
    plugins: 'link image code qm_code merge_tags', // priority matters as `qm_code` overrides `code` plugin
    toolbar: 'removeformat | ' +
      'styleselect | ' +
      'bold italic | ' +
      'backcolor forecolor | ' +
      'alignleft aligncenter alignright alignjustify | ' +
      'outdent indent | ' +
      'link | ' +
      'image | ' +
      'code | ' +
      '', // 'merge_tags',
    // not sure about `branding`, but this software is under MIT license
    merge_tags_list: DEFAULT_MERGE_TAGS,
    merge_tags_editable: true,
    branding: false,
    promotion: false,
    setup: (editor: any) => {
      CodePlugin(window.tinymce); // see `tinymce` defined in App.tsx
      /*MergeTagsPlugin();*/ // removed for now until fixing parsing bug
    },
    init_instance_callback: (editor: any) => {
    }
  }
};

export const shouldEmitChange = (editor: any, newContent: string) => {
  /*
   * HACK - tinymce editor emits an onEditorChange if we have multiple lines in the content,
   *   because of `\n` added to the content, and we remove the `\n` with `parseHTML` function.
   *
   * Please see usage.
   */
  let emit = true;
  if (!editor.isDirty()) {
    const undoManager = editor.undoManager || {};

    if (undoManager.data?.length) {
      const lastEntry = undoManager.data[undoManager.data?.length - 1];

      if (lastEntry.content === newContent) {
        /*
         * No change between current value and last entry
         */
        emit = false;
      }
    }
  }
  return emit;
};
